<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)">
      <div class="md-layout">
        <label class="md-layout-item md-size-20 md-form-label">
          Imię
        </label>
        <div class="md-layout-item md-xsmall-size-100">
          <ValidationProvider
            name="required"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-input v-model="firstName" type="text" name="name"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
      </div>
      <div class="md-layout">
        <label class="md-layout-item md-size-20 md-form-label">
          Nazwisko
        </label>
        <div class="md-layout-item md-xsmall-size-100">
          <ValidationProvider
            name="required"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-input v-model="lastName" type="text" name="surname">
              </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
      </div>
      <div class="md-layout">
        <label class="md-layout-item md-size-20 md-form-label">
          Email
        </label>
        <div class="md-layout-item md-xsmall-size-100">
          <ValidationProvider
            name="email"
            rules="required|email"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-input v-model="email" type="email" name="email"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
      </div>
      <div class="md-layout">
        <label class="md-layout-item md-size-20 md-form-label">
          Telefon
        </label>
        <div class="md-layout-item md-xsmall-size-100">
          <ValidationProvider
            name="number"
            :rules="{
              required: true,
              length: 11,
            }"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-input
                v-mask="'###-###-###'"
                v-model="phoneNumber"
                name="phone"
                type="tel"
              >
              </md-input>
              <span class="md-helper-text">
                Np. 732-111-222
              </span>
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>
      </div>
      <div class="md-layout">
        <div class="md-layout-item md-xsmall-size-100">
          <div class="cb-container">
            <ValidationProvider name="required" :rules="{ required: true }">
              <md-checkbox v-model="acceptRegulations" />
            </ValidationProvider>
            <div>
              Zapoznałem/am się i akceptuję
              <a :href="rulesUrl" target="_blank">regulamin serwisu</a>.
            </div>
          </div>
        </div>
      </div>
      <div class="md-layout">
        <div class="md-layout-item md-xsmall-size-100">
          <div class="cb-container">
            <md-checkbox v-model="acceptPersonalDataMarketing" />
            <div>
              Wyrażam zgodę na przetwarzanie moich danych osobowych przez
              Discoveria sp. z o.o. w celach marketingowych.
              <a href.prevent="/" @click="showInfoModal(modals.marketing1)">
                Pełna treść zgody
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="info-links">
        <a
          href="https://app.gorodo.pl/api/klauzula_informacyjna_klient/1132782112"
          rel="noopener"
          target="_blank"
        >
          Klauzula informacyjna o przetwarzaniu danych osobowych
        </a>
      </div>

      <md-card-actions class="text-center">
        <md-button :disabled="!validate" type="submit" class="md-info">
          <span>ZAMÓW SZCZEGÓŁOWY RAPORT</span>

          <md-icon>
            <md-progress-spinner
              :md-diameter="15"
              :md-stroke="2"
              md-mode="indeterminate"
              v-if="pending"
              class="button-spinner"
            />
            <span v-else>picture_as_pdf</span>
          </md-icon>
        </md-button>
      </md-card-actions>
      <ConfiguratorModal ref="modalInfo" />
    </form>
  </ValidationObserver>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import Swal from 'sweetalert2'
import ConfiguratorModal from './ConfiguratorModal'
// eslint-disable-next-line no-unused-vars
import Axios from 'axios'
import { extend } from 'vee-validate'
import {
  required,
  numeric,
  regex,
  confirmed,
  email,
  length,
} from 'vee-validate/dist/rules'
import { mapState } from 'vuex'
extend('required', required)
extend('email', email)
extend('numeric', numeric)
extend('regex', regex)
extend('confirmed', confirmed)
extend('length', length)
export default {
  components: {
    ConfiguratorModal,
  },
  data() {
    return {
      pending: false,
      acceptRegulations: false,
      acceptPersonalDataMarketing: false,
      agreedEmail: false,
      agreedPhone: false,
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      calculation: null,
      modals: {
        marketing1: {
          title: '',
          text: [
            `Wyrażam zgodę na przesyłania mi informacji marketingowych dotyczących produktów i usług oferowanych przez DISCOVERIA sp. z o.o. za pomocą środków komunikacji elektronicznej (stosownie do treści przepisu art. 10 ust. 1 i 2 ustawy o świadczeniu usług drogą elektroniczną) oraz telekomunikacyjnych urządzeń końcowych (stosownie do treści przepisu art. 172 ust. 1 Prawa telekomunikacyjnego).`,
          ],
        },
      },
    }
  },
  mounted() {
    this.calculation = JSON.parse(localStorage.getItem('calculation'))
  },
  computed: {
    ...mapState({
      rulesUrl: state => state.rulesDocUrl,
    }),
    validate() {
      return (
        this.acceptRegulations &&
        this.firstName &&
        this.lastName &&
        this.email &&
        this.phoneNumber
      )
    },
  },
  methods: {
    showInfoModal(data) {
      this.$refs.modalInfo.open(data)
    },
    submit() {
      if (!this.pending) {
        this.pending = true
        Axios.post(
          `${process.env.VUE_APP_API_URL}/CRM/api/CalculationData/PushData`,
          {
            ...this.calculation,
            email: this.email,
            name: this.firstName.trim(),
            surname: this.lastName.trim(),
            phone: this.phoneNumber,
            agreedPersonalData: this.acceptPersonalDataMarketing,
            agreedEmail: false,
            agreedPhone: false,
            url: window.location.origin + this.$store.state.query,
          }
        ).then(() => {
          this.pending = false
          Swal.fire({
            closeOnEsc: false,
            closeOnClickOutside: false,
            icon: 'success',
            title: `Dziękuję. Sprawdź mail`,
            buttonsStyling: false,
            confirmButtonClass: 'md-button md-info',
          }).then(() => {
            localStorage.removeItem('calculation')
            localStorage.removeItem('birthday')
            this.$router.push({ path: `${this.$store.state.query}` })
          })
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.text-center {
  justify-content: center !important;
}
.md-layout .md-form-label {
  @media screen and (max-width: 576px) {
    text-align: left;
  }
}

.cb-container {
  font-size: 12px;
  display: flex;
  align-items: center;
  text-wrap: balance;
  margin-top: -14px;
  div:last-child {
    padding-top: 14px;
  }
  a {
    cursor: pointer;
  }
}
.agreement-info {
  font-size: 11px;
  line-height: 1.4em;
  margin-top: 15px;
}

.info-links {
  margin-top: 10px;
  text-align: center;
}

.info-links a {
  font-size: 12px;
}
</style>
